var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"id":"input-1-group","label":"Url จาก third party","label-for":"url-input"}},[_c('b-form-input',{attrs:{"id":"url-input","type":"url","required":""},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }